<p-dialog
  [modal]="true"
  [closable]="true"
  [header]="data()?.title"
  [(visible)]="visible"
  (onHide)="onCancel()"
  styleClass="pssr-dialog">
  <div class="dialog-content">
    @if (data()?.description) {
      <p [innerHTML]="data()?.description"></p>
    }

    @if (data()?.childTemplate) {
      <ng-container>
        <ng-container *ngTemplateOutlet="data()?.childTemplate; context: data()?.childContext"></ng-container>
      </ng-container>
    }
  </div>

  <ng-template #footer>
    <button
      (click)="onCancel()"
      class="pssr-button small secondary">
      {{ data()?.cancelLabel }}
    </button>
    <button
      (click)="onConfirm()"
      class="pssr-button small primary">
      {{ data()?.confirmLabel }}
    </button>
  </ng-template>
</p-dialog>
